import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const transportForLondon = defineConnector({
  identifier: "transportForLondon",
  name: "Transport for London",
  tagLine: "London line status, arrivals, and journey planning",
  keywords: "tfl unified api tube underground dlr overground elizabeth line",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("api.tfl.gov.uk"),
  auth: (app) => queryAuth([{ name: "app_key", value: app.secret.appKey }]),
  steps: [
    {
      title: "Register for an app key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at the [**TfL API portal**](https://api-portal.tfl.gov.uk/), then open **Products** and add an application to get its app key.",
        },
      ],
    },
    {
      title: "Copy and paste the app key into the field below",
      items: [
        {
          kind: "input",
          label: "App key",
          required: true,
          target: { kind: "secrets", field: "appKey" },
          helperText:
            "The Unified API answers unauthenticated requests too, but throttles them aggressively — a key raises the limit.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.tfl.gov.uk/Line/Mode/tube/Status",
  },
});
